import { axios } from '@Root/API'

export const edit = (entryQualificationAwardId, id, payload) => {
	return axios.put(`qualification-award/${entryQualificationAwardId}/qualification-subject/${id}`, payload)
}
